import { render } from "./DataStreamPanel.vue?vue&type=template&id=06140a37"
import script from "./DataStreamPanel.vue?vue&type=script&lang=js"
export * from "./DataStreamPanel.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__